export default function IosSnowy() {
  return (
    <div
      className="ion-icon-ios-snowy"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<path class="st0" d="M379.9,317l-28.7-16.3c6.1-5.8,13-9.7,20.7-12.3c4.3-1.4,6.5-5.9,5.1-10.1c-1.4-4.2-6-6.5-10.3-5.1
	c-11.6,3.8-22.2,11-30.1,19.2L272.3,256l64.2-36.4c8.4,9.1,18.6,15.4,30.2,19.2c4.3,1.4,8.9-0.8,10.3-5c1.4-4.2-0.8-8.7-5.1-10.1
	c-7.8-2.6-14.8-6.5-20.9-12.3l28.8-16.3c3.9-2.2,5.2-7.1,3-10.9s-7.2-5.1-11.1-2.9L343,197.3c-2-8.1-2.1-15.9-0.5-23.8
	c0.9-4.3-2-8.5-6.4-9.4c-4.4-0.9-8.7,1.9-9.6,6.2c-2.4,11.8-1.4,24.4,1.8,35.2L264,242.2v-73c11-2.7,22.4-8.1,31.5-16.1
	c3.3-2.9,3.6-8,0.7-11.3c-2.9-3.3-7.9-3.6-11.3-0.7c-6,5.3-12.9,9.2-20.9,11.5V120c0-4.4-3.6-8-8-8c-4.4,0-8,3.6-8,8v32.7
	c-8-2.3-14.8-6.2-20.9-11.6c-3.3-2.9-8.4-2.6-11.3,0.7c-2.9,3.3-2.6,8.4,0.7,11.3c9.1,8,19.5,13.5,31.5,16.1v73l-64.5-36.6
	c3.2-10.9,4.2-23.5,1.9-35.2c-0.9-4.3-5.2-7.1-9.6-6.2c-4.4,0.9-7.2,5-6.4,9.4c1.6,7.9,1.6,15.7-0.5,23.8L140.3,181
	c-3.9-2.2-8.9-0.9-11.1,2.9c-2.2,3.8-0.9,8.7,3,10.9l28.8,16.3c-6.1,5.8-13,9.7-20.8,12.3c-4.3,1.4-6.5,6-5.1,10.1
	c1.4,4.2,6.1,6.4,10.3,5c11.6-3.9,21.8-10.1,30.2-19.2l64.3,36.5l-64.4,36.5c-7.9-8.2-18.6-15.3-30.1-19.2
	c-4.3-1.4-8.8,0.9-10.3,5.1c-1.4,4.2,0.8,8.7,5.1,10.1c7.7,2.6,14.6,6.5,20.7,12.3l-28.7,16.3c-3.9,2.2-5.2,7.1-3,10.9
	s7.2,5.1,11.1,2.9l28.8-16.3c2.1,8.1,2.1,15.9,0.4,23.9c-0.9,4.3,2,8.5,6.4,9.4c4.4,0.9,8.7-1.9,9.6-6.3c2.4-11.8,1.9-23.6-1.9-35.3
	l64.5-36.6v73.1c-12,2.6-22.4,8.1-31.5,16.1c-3.3,2.9-3.6,8-0.7,11.3c2.9,3.3,7.9,3.6,11.3,0.7c6.1-5.4,12.9-9.3,20.9-11.6V392
	c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8v-32.6c8,2.3,14.8,6.2,20.9,11.5c3.3,2.9,8.3,2.6,11.3-0.7c2.9-3.3,2.6-8.4-0.7-11.3
	c-9-7.9-20.4-13.4-31.4-16.1v-73.1l64.4,36.5c-3.8,11.7-4.2,23.5-1.8,35.3c0.9,4.3,5.2,7.1,9.6,6.3c4.4-0.9,7.3-5.1,6.4-9.4
	c-1.6-8-1.6-15.8,0.4-23.9l28.8,16.3c3.9,2.2,8.9,0.9,11.1-2.9C385.2,324.1,383.8,319.2,379.9,317z"/>
</svg>
`,
      }}
    />
  )
}
